/**
 * @file
 * Trigger button scripts.
 */

const $userPageSlideshow = $('.user-page-slideshow', context);

$userPageSlideshow.once('user-page-slideshow').each((index, el) => {
  const $this = $(el);

  const slideshowOptions = {
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  };

  $this.slick(slideshowOptions);
});
